import { socialExport } from '@mi-front/api-clients';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';

interface Props {
  profile: socialExport.GetConnectionProfileDto;
}

export const ProfileInfo = ({ profile }: Props) => {
  return (
    <Box mt={2}>
      <FormattedMessage
        id="socialExport.profile.videosWillBeUploadedTo"
        defaultMessage="Los vídeos serán subidos a"
      />{' '}
      <strong>{profile.displayName}</strong>
      {profile.photo && (
        <img
          width={30}
          height={30}
          style={{ marginLeft: 8, borderRadius: '50%' }}
          src={profile.photo}
        />
      )}
    </Box>
  );
};
